// Types
import Strategy from 'app/types/Strategy';
import MixpanelEvents from 'app/features/mixpanel/MixpanelEvents';
// Services
import Mixpanel from "app/services/Mixpanel.service";

export const handleCalendarEpisodePagePreviewOpenStrategy:Strategy = (payload, { caseId, accountId }) => {
  const { documentId, pageNum } = payload;
  Mixpanel.track(MixpanelEvents.CalendarEpisodePagePreviewOpen, {
    caseId,
    documentId,
    pageNum
  });
};

export const handleCalendarEpisodePageLinkOpenStrategy:Strategy = (payload, { caseId, accountId }) => {
  const { documentId, pageNum } = payload;
  Mixpanel.track(MixpanelEvents.CalendarEpisodePageLinkOpen, {
    caseId,
    documentId,
    pageNum
  });
};
